/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinqrprint2Inputs */

const en_checkinqrprint2 = /** @type {(inputs: Checkinqrprint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print`)
};

const de_checkinqrprint2 = /** @type {(inputs: Checkinqrprint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drucken`)
};

/**
* | output |
* | --- |
* | "Print" |
*
* @param {Checkinqrprint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrprint2 = /** @type {((inputs?: Checkinqrprint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrprint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrprint2(inputs)
	return de_checkinqrprint2(inputs)
});
export { checkinqrprint2 as "checkinQrPrint" }